// SearchMap.tsx

import React, { useEffect, useState, useRef } from 'react';
import { GoogleMap, Marker as GoogleMapMarker, useJsApiLoader } from '@react-google-maps/api';
import { googleMapStyles } from '../../util/googleMapStyles';
import { events } from '../../util/Events';
import uniqBy from 'lodash/uniqBy';

export interface Place {
  lat: string;
  lng: string;
  id: string;
}

interface SearchMapProps {
  places: Place[];
  activeItem: string;
}

const containerStyle = {
  height: '40vh',
  width: '100%',
};

const defaultCenter = { lat: 52.3676, lng: 5.218506 };
const defaultZoom = 7;

export const SearchMap: React.FC<SearchMapProps> = ({ places }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAx37KXOgn9MRHQuHoVItl5SkMCTDXispA',
    language: 'nl',
    region: 'NL',
    libraries: ['places', 'geocoding'],
  });

  const mapRef = useRef<google.maps.Map>(null);
  const geocoderRef = useRef<google.maps.Geocoder | null>(null);
  const [currentLocation, setCurrentLocation] = useState<{ lat: number; lng: number } | null>(null);
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  useEffect(() => {
    if (isLoaded) {

      const pageData = $('[data-container="search-results"]').data('data');
      const queryParams = new URLSearchParams(window.location.search);
      //const location = queryParams.get('city');
      const location = (pageData && pageData.city) ? pageData.city : queryParams.get('city') || null;

      console.log("location");
      console.log(location);

        if (location) {
            geocoderRef.current = new google.maps.Geocoder();

            geocoderRef.current.geocode({ address: location }, (results, status) => {
          if (status === 'OK') {
            const { lat, lng } = results[0].geometry.location;
            setCurrentLocation({ lat: lat(), lng: lng() });
          } else {
            console.error('Geocode was not successful for the following reason:', status);
            fetchCurrentLocation();
          }
        });
      } else {
        fetchCurrentLocation();
      }
    }
  }, [isLoaded]);

  const fetchCurrentLocation = () => {
    if ('permissions' in navigator && 'geolocation' in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          // Permission already granted
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              setCurrentLocation({ lat: latitude, lng: longitude });
            },
            (error) => {
              console.error('Error fetching geolocation:', error);
              setCurrentLocation(null);
            }
          );
        } else {
          // Permission not granted or denied
          console.log('Geolocation permission not granted.');
          setCurrentLocation(null);
        }
      });
    } else {
      console.log('Geolocation or Permissions API not supported by this browser.');
      setCurrentLocation(null);
    }
  };


  //useEffect(() => {
  //  const listeners = [];
  //
  //  uniqBy(places, (place) => place.id).forEach((place) => {
  //    const element = document.querySelector(`[data-id='${place.id}']`);
  //    if (element) {
  //      const handleMouseEnter = () => {
  //        setHoveredId(place.id);
  //        if (mapRef.current) {
  //          const bounds = new window.google.maps.LatLngBounds();
  //          if (currentLocation) {
  //            bounds.extend(new window.google.maps.LatLng(currentLocation.lat, currentLocation.lng));
  //          }
  //          bounds.extend(new window.google.maps.LatLng(parseFloat(place.lat), parseFloat(place.lng)));
  //          mapRef.current.fitBounds(bounds);
  //          if (!currentLocation) {
  //            mapRef.current.setZoom(10);
  //          }
  //        }
  //      };
  //
  //      const handleMouseLeave = () => {
  //        setHoveredId(null);
  //        if (mapRef.current) {
  //          if (currentLocation) {
  //            mapRef.current.setCenter(new google.maps.LatLng(currentLocation.lat, currentLocation.lng));
  //            mapRef.current.setZoom(defaultZoom);
  //          } else {
  //            mapRef.current.setCenter(new google.maps.LatLng(defaultCenter.lat, defaultCenter.lng));
  //            mapRef.current.setZoom(defaultZoom);
  //          }
  //        }
  //      };
  //
  //      element.addEventListener('mouseenter', handleMouseEnter);
  //      element.addEventListener('mouseleave', handleMouseLeave);
  //
  //      listeners.push({ element: element, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave });
  //    }
  //  });
  //
  //  return () => {
  //    listeners.forEach(({ element, handleMouseEnter, handleMouseLeave }) => {
  //      element.removeEventListener('mouseenter', handleMouseEnter);
  //      element.removeEventListener('mouseleave', handleMouseLeave);
  //    });
  //  };
  //}, [places, currentLocation]);

  const handleMarkerClick = (id: string): void => {
    events.emit('SearchActive', id);
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  return isLoaded ? (
    <div className='google-map google-map--resizable' style={containerStyle}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        onLoad={(map) => {
          mapRef.current = map;
        }}
        center={currentLocation || defaultCenter}
        zoom={defaultZoom}
        options={{
          mapTypeControl: false,
          scrollwheel: false,
          fullscreenControl: false,
          styles: googleMapStyles,
        }}
      >
        {currentLocation && (
          <GoogleMapMarker
            position={currentLocation}
            icon={{
              url: '/wp-content/themes/lyceo-2015/images/marker-yellow.svg',
              scaledSize: new google.maps.Size(48, 48),
            }}
          />
        )}
        {places.map((place, key) => (
          <GoogleMapMarker
            key={key}
            position={{ lat: parseFloat(place.lat), lng: parseFloat(place.lng) }}
            onClick={() => handleMarkerClick(place.id)}
            icon={{
              url: hoveredId === place.id ? '/wp-content/themes/lyceo-2015/images/marker-blue.svg' : '/wp-content/themes/lyceo-2015/images/marker.svg',
              scaledSize: new google.maps.Size(hoveredId === place.id ? 48 : 32, hoveredId === place.id ? 48 : 32),
            }}
          />
        ))}
      </GoogleMap>
    </div>
  ) : <div>Loading...</div>;
};
